<div class="credit-info-container flex flex-column gap-3 mb-5">
  <div class="flex flex-column gap-3">
    <div>
      <span class="title">
        <app-translate key="ACCOUNT_VERIFICATION"></app-translate>
      </span>
    </div>
    <p-divider></p-divider>
  </div>
  @if (wirelessAccountAuthenticationForm) {
    <div>
      <fieldset  class="p-0 border-none">
        <sp-form-wrapper [formGroup]="wirelessAccountAuthenticationForm">
          <div class="flex flex-column gap-3 align-items-center text-center pt-2">
            <!-- Step 1: Phone Number Entry -->
            <div>
              <span class="font-semibold text-base">
                <app-translate key="PHONE_NUMBER_VERIFY_DESCRIPTION"></app-translate>
              </span>
            </div>
            <div class="flex flex-column gap-3 w-12 md:w-6">
              <div class="align-self-center flex flex-column md:w-8 text-left w-12">
                <label htmlFor="attPhoneNumber" class="form-label required">
                  <app-translate key="ATT_PHONE_NUMBER_FIELD"></app-translate>
                </label>
                <input type="text" class="w-full skinny" (input)="formatPhone($event, 'attPhoneNumber')"
                  placeholder="Enter a phone #" max="12" maxlength="12" pInputText
                  formControlName="attPhoneNumber" />
                <sp-control-error [parameters]="['AT&T Phone Number']"
                  [messagesParameters]="[{key : 'required', message : 'AT&T Phone Number is required'}]"
                [control]="wirelessAccountAuthenticationForm.controls['attPhoneNumber']"></sp-control-error>
              </div>
              <!-- Search Button -->
              @if (showSearchButton()) {
                <div>
                  <p-button icon="pi pi-search" [styleClass]="'button-secondary border-round-lg'"
                  [label]="languageService.getTranslation('SEARCH')" (click)="searchClicked()" [outlined]="true"></p-button>
                </div>
              }
              <!-- Step 2: Zip and SSN Fields -->
              @if (showZipAndSsnFields()) {
                <div class="align-items-center flex flex-column gap-3 w-full"
                  >
                  <div class="align-self-center flex flex-column md:w-8 text-left w-12">
                    <label htmlFor="attBillingZip" class="form-label required">
                      <app-translate key="ATT_BILLING_ZIP_FIELD"></app-translate>
                    </label>
                    <input type="text" placeholder="Enter billing zip" pInputText (keypress)="onlyNumbers($event)"
                      formControlName="attBillingZip" class="mb-1 skinny w-full" maxlength="5" />
                    <sp-control-error [parameters]="['AT&T Billing Zip']"
                      [messagesParameters]="[{key : 'required', message : 'AT&T Billing Zip is required'}]"
                    [control]="wirelessAccountAuthenticationForm.controls['attBillingZip']"></sp-control-error>
                  </div>
                  <div class="align-self-center flex flex-column md:w-8 text-left w-12">
                    <label htmlFor="last4Ssn" class="form-label required">
                      <app-translate key="Last_4_SSN"></app-translate>
                    </label>
                    <input type="text" id="last4Ssn" placeholder="Enter last 4 of SSN" pInputText appNumericOnly inputmode="tel"
                      formControlName="last4Ssn" appMaskInput class="mb-1 skinny w-full"
                      [maxDigits]="4" />
                    <sp-control-error [parameters]="['Last 4 of SSN']"
                      [messagesParameters]="[{key : 'required', message : 'Last 4 of SSN is required'}]"
                    [control]="wirelessAccountAuthenticationForm.controls['last4Ssn']"></sp-control-error>
                  </div>
                </div>
              }
            </div>
            <!-- Verify Account Button -->
            @if (showVerifyAccountButton()) {
              <div>
                <p-button [styleClass]="'button-secondary border-round-lg'" [label]="languageService.getTranslation('VERIFY_ACCOUNT')"
                (click)="verifyAccountClicked()" [outlined]="true"></p-button>
              </div>
            }
            <p-divider class="w-full"></p-divider>
            <!-- Step 3: Authentication Section -->
            @if (showAuthenticationSection()) {
              <div class="flex flex-column gap-3 align-items-center text-center pt-2">
                <div>
                  <span class="font-semibold text-sm">
                    {{fdeMessage}}
                  </span>
                </div>
                <!-- PIN / Passcode Selection -->
                <div class="flex flex-column gap-3 w-full">
                  <!-- Show phone number field ONLY for one-time PIN -->
                  @if (isOneTimePinSelected()) {
                    <div class="align-self-center flex flex-column md:w-8 text-left w-12"
                      >
                      <label htmlFor="attPhoneNumber" class="form-label required">
                        <app-translate key="ATT_PHONE_NUMBER_FIELD"></app-translate>
                      </label>
                      <input type="text" class="w-full skinny" (input)="formatPhone($event, 'attPhoneNumber')"
                        placeholder="Enter a phone #" max="12" maxlength="12" pInputText
                        formControlName="attPhoneNumber" />
                      <sp-control-error [parameters]="['AT&T Phone Number']"
                        [messagesParameters]="[{key : 'required', message : 'AT&T Phone Number is required'}]"
                      [control]="wirelessAccountAuthenticationForm.controls['attPhoneNumber']"></sp-control-error>
                    </div>
                  }
                  <!-- Request PIN Button - only for one-time PIN -->
                  @if (showRequestPinButton() && isOneTimePinSelected()) {
                    <div>
                      <p-button [styleClass]="'button-secondary border-round-lg'" label="REQUEST PIN"
                      (click)="requestPinClicked()" [outlined]="true"></p-button>
                    </div>
                  }
                  <!-- One-time PIN / Account Passcode Input -->
                  @if (showPinAndAccountPasscodeFields()) {
                    <div class="align-items-center flex flex-column gap-3 w-full"
                      >
                      <!-- One-time PIN input -->
                      @if (showOnetimePinOption() && isOneTimePinSelected()) {
                        <div class="align-self-center flex flex-column md:w-8 text-left w-12"
                          >
                          <label htmlFor="oneTimePin" class="form-label">
                            <app-translate key="ONE_TIME_PIN_FIELD"></app-translate>
                          </label>
                          <input type="text" placeholder="Enter pin" pInputText formControlName="oneTimePin"
                            class="mb-1 skinny w-full" />
                          <sp-control-error [parameters]="['PIN']"
                            [messagesParameters]="[{key : 'required', message : 'PIN is required'}]"
                          [control]="wirelessAccountAuthenticationForm.controls['oneTimePin']"></sp-control-error>
                        </div>
                      }
                      <!-- NEW: Account Passcode input -->
                      @if (showPasscodeOption() && isAccountPasscodeSelected()) {
                        <div class="align-self-center flex flex-column md:w-8 text-left w-12"
                          >
                          <div class="flex align-items-center w-full mb-2">
                            <label htmlFor="accountPasscode" class="form-label required">
                              <app-translate key="ACCOUNT_PASSCODE"></app-translate>
                            </label>
                            <i class="pi pi-info-circle text-blue-500 cursor-pointer ml-auto"
                            (click)="banInfo.toggle($event)"></i>
                            <p-popover #banInfo styleClass="w-20rem">
                              <div class="font-semibold mb-2">What is it?</div>
                              <div>
                                For security reasons, your passcode cannot be retrieved - only reset.
                                Sign in at <a href="https://www.att.com/" target="_blank">att.com</a> to
                                change it, or use the myAT&T app. If you're locked out, call AT&T for
                                help.
                              </div>
                            </p-popover>
                          </div>
                          <input type="text" placeholder="Enter passcode" pInputText appNumericOnly
                            inputmode="tel" formControlName="accountPasscode" class="mb-1 skinny w-full" />
                          <sp-control-error [parameters]="['Account Passcode']"
                            [messagesParameters]="[{key : 'required', message : 'Account Passcode is required'}]"
                          [control]="wirelessAccountAuthenticationForm.controls['accountPasscode']"></sp-control-error>
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- Submit PIN/Passcode Button -->
                @if (showSubmitPinButton()) {
                  <div>
                    <p-button [styleClass]="'button-secondary border-round-lg'" label="SUBMIT"
                    (click)="submitPinClicked()" [outlined]="true"></p-button>
                  </div>
                }
              </div>
            }
          </div>
        </sp-form-wrapper>
      </fieldset>
    </div>
  }
  <div>

    <div class="mb-3">
      <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
        (onClick)="onCancelClick()" />
    </div>
    <div>
      <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
    </div>
  </div>
</div>



<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancel($event)"></app-confirm-popup>

